import React from "react";
import "./notificationComponent.css";

const NotificationComponent = ({ notifications }) => {
  return (
    <div>
      {notifications.map((notificationData) => {


        const getTypeMessage = (type) => {
          switch (type) {
            case 0:
              return "Home > Edit Request > Category Edit Request";
            case 1:
              return "Home > Edit Request > Service Edit Request";
            case 2:
              return  "Home > Alert > Service Alert";
            case 3:
              return "Home > Alert > category Alert";
            case 4:
              return "Home > Alert";
              case 5:
              return "Home > Other Services";
            default:
              return "";
          }
        };

        const { id, notification, timestamp } = notificationData;
        const { title, body, is_refund, type } = notification;

        const typeMessage = getTypeMessage(type);

        return (
          <div key={id} className={`notification-card refund`}>
            <h3 className="notification-title">{title}</h3>
            <p className="notification-body">{body}</p>
            <h6 className="refunded">{is_refund ? "Refunded" : ""}</h6>
            <h6 className="refunded">{typeMessage}</h6>
            <span className="notification-timestamp">
              {new Date(timestamp).toLocaleString("en-GB")}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationComponent;
